import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de simulation de vente marchande
 * (`POST /MerchantSales/simulate-wallet-transaction-completed`).
 *
 * Les identifiants restent des UUID (sortie API) : l’UX du dialog est un
 * `EntitySearchableSelect` (libellé humain → UUID). `qrPayloadToken` n’est
 * pas un UUID — c’est le jeton public du QR (`GET /QrCodes/merchant/{id}`).
 */
export const createSimulateSaleSchema = () =>
  z.object({
    walletTransactionId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") }),
    customerWalletId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") }),
    settlementWalletId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") }),
    qrPayloadToken: z.string().trim().min(1, { message: t("requiredFieldError") }),
    amount: z.number().positive({ message: t("invalidFieldError") }),
    fee: z.number().min(0, { message: t("invalidFieldError") }),
    currency: z.string().trim().min(1, { message: t("requiredFieldError") }),
    completedAt: z.string().trim().min(1, { message: t("requiredFieldError") }),
  });

export type SimulateSaleFormValues = z.infer<
  ReturnType<typeof createSimulateSaleSchema>
>;
